import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_PAYERS_REQUEST, fetchPayersSuccess, fetchPayersFailure,
  CREATE_PAYER_REQUEST, createPayerSuccess, createPayerFailure,
  UPDATE_PAYER_REQUEST, updatePayerSuccess, updatePayerFailure,
  DELETE_PAYER_REQUEST, deletePayerSuccess, deletePayerFailure
} from '../actions/payerActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchPayers(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching payer with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/payers`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchPayersSuccess(response.data));
  } catch (error) {
    console.error("Error fetching State: ", error);
    yield put(fetchPayersFailure(error.response?.data?.message || error.message));
  }
}

function* createPayer(action) {
  try {
    const { id, ...data } = action.payload;
    const projectId = id;
    console.log("Payer saga ",data,id)
    const response = yield call(axios.post, `${API_BASE_URL}/${projectId}/payers`, data, createConfig());
    yield put(createPayerSuccess(response.data));
  } catch (error) {
    yield put(createPayerFailure(error.message));
  }
}

function* updatePayer(action) {
  try {
    const { id, data } = action.payload;
    const projectId = data.id
    delete data.id
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/payers/${id}`, data, createConfig());
    yield put(updatePayerSuccess(response.data));
  } catch (error) {
    yield put(updatePayerFailure(error.message));
  }
}

function* deletePayer(action) {
  try {
    const { id, projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/payers/${id}`, createConfig());
    yield put(deletePayerSuccess(id));
  } catch (error) {
    yield put(deletePayerFailure(error.message));
  }
}

export default function* payerSaga() {
  yield takeLatest(FETCH_PAYERS_REQUEST, fetchPayers);
  yield takeLatest(CREATE_PAYER_REQUEST, createPayer);
  yield takeLatest(UPDATE_PAYER_REQUEST, updatePayer);
  yield takeLatest(DELETE_PAYER_REQUEST, deletePayer);
}
